import { render, staticRenderFns } from "./ModalMultiSelect.vue?vue&type=template&id=ed632700&"
import script from "./ModalMultiSelect.vue?vue&type=script&lang=ts&"
export * from "./ModalMultiSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports